import api from './api';
import { ENDPOINTS } from '../utils/constants';
import { formatApiError, logError } from '../utils/errorHandler';

/**
 * Fetch all open mill sessions.
 * Customers and employees both use the same data; the endpoint is role-specific.
 *
 * @param {Object} options
 * @param {boolean} options.employee - Use the employee endpoint (default: false)
 * @returns {Promise<Array>} - Array of open MillSession objects
 */
export const getSessions = async ({ employee = false } = {}) => {
  const url = employee
    ? ENDPOINTS.SESSIONS.EMPLOYEE.LIST
    : ENDPOINTS.SESSIONS.CUSTOMER.LIST;

  try {
    const response = await api.get(url);
    return response.data.results ?? response.data;
  } catch (error) {
    logError('Get sessions', error);
    throw formatApiError(error);
  }
};
